import React, { FocusEventHandler } from 'react';

import { InputError } from '../../library/input/input-types';
import Quantity from '../../library/quantity/quantity';
import StaticQuantity from '../static-quantity/static-quantity';

import { useFitment, useTireWheelPackage } from '../../shared/hooks/hooks';

export interface ProductQuantityProps {
  className?: string;
  defaultValue: number;
  error?: InputError;
  id?: string;
  isDisabled?: boolean;
  isHorizontal?: boolean;
  isReadOnly?: boolean;
  isRequired?: boolean;
  max?: number;
  min?: number;
  name?: string;
  onBlur?: (e: Event, quantity: number) => void;
  onChange?: (e: Event, quantity: number) => void;
  onFocus?: FocusEventHandler<HTMLInputElement>;
  showLabel?: boolean;
  value?: number;
}

function ProductQuantity(props: ProductQuantityProps) {
  const { className, isHorizontal = false, max, min } = props;
  const { currentTireWheelPackageFlow } = useTireWheelPackage();
  const { selectedFitment } = useFitment();

  return currentTireWheelPackageFlow ? (
    <StaticQuantity
      className={className}
      isHorizontal={isHorizontal}
      quantity={selectedFitment?.isStaggered ? 2 : 4}
      variant="H6"
    />
  ) : (
    <Quantity {...props} max={max ?? 99} min={min ?? 1} />
  );
}

export default ProductQuantity;
